export default __webpack_public_path__ + "static/media/filter-white.778dd129.svg";